var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'page-message': true, invert: _vm.invert, flash: _vm.flash}},[(_vm.title!=='')?_c('h2',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }